import axios from "axios";
import { environment } from "../../../../environment";
import { errorLog } from "../../../../logger";
import ValidationError from "../../../ZodError";
import { GoalBasedFinancialPlanIncomeResponseSchema, } from "../types";
export const url = (goalBasedFinancialPlanId, goalBasedFinancialPlanIncomeId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/financial-planning/goal-based/${goalBasedFinancialPlanId}/income/${goalBasedFinancialPlanIncomeId}`
    : `https://middleware.uat.farther.com/financial-planning/goal-based/${goalBasedFinancialPlanId}/income/${goalBasedFinancialPlanIncomeId}`;
const patchGoalBasedFinancialPlanIncome = async (goalBasedFinancialPlanId, goalBasedFinancialPlanIncomeId, body, idempotencyKey, config) => {
    const { data } = await axios.patch(url(goalBasedFinancialPlanId, goalBasedFinancialPlanIncomeId), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            "Idempotency-key": idempotencyKey,
            Version: "20240925",
        },
    });
    const decoded = GoalBasedFinancialPlanIncomeResponseSchema.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[patchFinancialPlanGoalIncome] Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
export default patchGoalBasedFinancialPlanIncome;
//# sourceMappingURL=patchGoalBasedFinancialPlanIncome.js.map